import type { SegmentSize } from './types'

/**
 * Высота сегмента по size — 36 базовая (спека 01 §29), 32 компактная для тесных рядов.
 * Точных токенов нет (ближайший $control-height-s — 44, заметно выше), поэтому это
 * задокументированное отклонение.
 */
export const SEGMENT_HEIGHT: Record<SegmentSize, string> = {
  S: '32px',
  M: '36px',
}
